<template>
    <component
        :is="field.headingSize"
        :class="field.headingSize"
        class="formie-page__heading"
    >
        {{ field.label }}
    </component>
</template>

<script setup>
defineProps({
    field: {
        type: Object,
        required: true,
    }
});
</script>

<style lang="less">
.formie-page__heading {
    .typography-h4();
    padding-top: 1.5em;
}
</style>
